import { DEFAULT_CHAT_ICON_POSITION } from './constants';
import {
  ChatIconPosition,
  ChatIconSize,
  NormalizedStartParameters,
  StartParameters,
} from './types';

export const makeIncompleteStartError = (methodName) => {
  return `${methodName} can only be run after Kustomer.start() completes or in the callback of Kustomer.start().`;
};

export const parseChatIconSize = (
  chatIconSize?: number | string | ChatIconSize,
) => {
  if (typeof chatIconSize === 'string') {
    if (chatIconSize.trim().length === 0) return undefined;
    const size = Number(chatIconSize?.replace('px', ''));
    if (Number.isNaN(size)) {
      throw Error('Unable to parse chatIconSize parameter');
    }
    return {
      height: size,
      width: size,
    };
  }
  if (typeof chatIconSize === 'number') {
    return {
      height: chatIconSize,
      width: chatIconSize,
    };
  }
  if (
    typeof chatIconSize?.height === 'number' &&
    typeof chatIconSize?.width === 'number'
  ) {
    return chatIconSize;
  }
  if (chatIconSize) {
    throw Error('Unable to parse chatIconSize parameter');
  }
  return undefined;
};

export const parseChatIconPosition = (
  chatIconPosition?: string | ChatIconPosition,
) => {
  const position: ChatIconPosition = { ...DEFAULT_CHAT_ICON_POSITION };
  if (chatIconPosition && typeof chatIconPosition === 'string') {
    if (chatIconPosition === 'right' || chatIconPosition === 'left')
      position.alignment = chatIconPosition;
    else {
      throw Error('Unable to parse chatIconPosition parameter');
    }
  }
  if (typeof chatIconPosition === 'object') {
    Object.assign(position, chatIconPosition);
  }
  if (
    !['right', 'left'].includes(position.alignment) ||
    typeof position.horizontalPadding !== 'number' ||
    typeof position.verticalPadding !== 'number'
  ) {
    throw Error('Unable to parse chatIconPosition parameter');
  }
  return position;
};

export const parseStartParameters = (
  startParameters?: StartParameters,
): NormalizedStartParameters => {
  if (!startParameters)
    return {
      chatIconPosition: DEFAULT_CHAT_ICON_POSITION,
    };
  return {
    ...startParameters,
    chatIconSize: parseChatIconSize(startParameters?.chatIconSize),
    chatIconPosition: parseChatIconPosition(startParameters?.chatIconPosition),
  };
};

export const setKustomerStyleSheetOnParent = () => {
  const sheetExists = window.document?.getElementById('kustomer-mobile-style');

  if (sheetExists) return;

  const parentHead = window.document?.head;

  const kustomerParentStyleSheet = window.document?.createElement('style');

  kustomerParentStyleSheet.id = 'kustomer-mobile-style';

  kustomerParentStyleSheet.innerHTML = `
    .kustomer-mobile-active { height: calc(100vh - 1px); }
    .kustomer-mobile-active,
    .kustomer-mobile-active > body { position: static !important; overflow: hidden !important; transform: none !important; }
    .kustomer-remove-scroll { scroll-behavior: unset !important; }
    `;

  parentHead?.appendChild(kustomerParentStyleSheet);
};
